<template>
  <button :id="id" @click="clickAction">
    <slot> </slot>
  </button>
</template>

<script>
export default {
  name: "Button",
  props: ["id"],
  data() {
    return {};
  },
  methods: {
    clickAction() {
      this.$emit("clickButton");
    },
  },
};
</script>

<style scoped>
button {
  font-family: Noto Sans Thai, Arial, Helvetica, sans-serif;
  cursor: pointer;
  background-color: #29a9e2;
  width: 100%;
  height: 56px;
  border-radius: 5px;
  border: 1px solid #29a9e2;
  font-size: 17px;
  text-align: center;
  color: #ffffff;
}
button:hover {
  font-weight: bold;
  border: 1px solid #008fc1;
  background-color: #008fc1;
}
button:focus {
  outline: unset;
}
button:disabled {
  border: 1px solid #d8d9e0;
  background-color: #d8d9e0;
  color: #b5b6bf;
  pointer-events: none;
  cursor: default;
}
button.button-secondary {
  background-color: #ffffff;
  color: #29a9e2;
}
button.button-secondary:hover {
  background-color: #ffffff;
}
button.button-secondary:disabled:disabled {
  color: #b5b6bf;
}
</style>
